<template lang="pug">
.Home
  ShareBtn.sharebtn(:text="$t('share_message')")
  MegaCanvas.megacanvas(ref="megacanvas")
  h2.bigText(
    :style="{ color: $store.state.lastCardColor, opacity: $store.state.hoveredCard ? 1 : 0 }"
    v-html="$store.state.lastCardTitle"
  )
  MiniMap.minimap(:displayMouse="true")
  .transition-helper
</template>

<script>
import gsap from 'gsap'
import MegaCanvas from '@/components/MegaCanvas'
import MiniMap from '@/components/MiniMap'
import ShareBtn from '@/components/ShareBtn'

export default {
  name: 'home',
  components: { MegaCanvas, MiniMap, ShareBtn },
  mounted () {
    this.$store.state.cards.forEach(card => {
      card.mesh.position.set(
        this.$store.state.loaderIsVisible || this.$store.state.inDarkPage ? card.stackedPosition.x : card.position.x,
        this.$store.state.loaderIsVisible || this.$store.state.inDarkPage ? card.stackedPosition.y : card.position.y,
        0
      )
    })

    this.$store.state.decorations.forEach(decoration => {
      decoration.mesh.position.set(
        this.$store.state.loaderIsVisible || this.$store.state.inDarkPage ? decoration.stackedPosition.x : decoration.position.x,
        this.$store.state.loaderIsVisible || this.$store.state.inDarkPage ? decoration.stackedPosition.y : decoration.position.y,
        0
      )
    })

    if (this.$store.state.cards.length > 0 && this.$store.state.cards.every(card => card.hasBeenVisited)) {
      setTimeout(() => this.$router.push({ name: 'finale' }), 2500)
    }

    this.$store.commit('inDarkPage', false)
    gsap.fromTo(document.body, { backgroundColor: '#000000' }, { backgroundColor: this.$store.state.colors.light, ease: 'expo.inOut', duration: 1 })
    gsap.fromTo(this.$el, { autoAlpha: 0 }, { autoAlpha: 1, ease: 'expo.inOut', duration: 1 })

    this.$el.addEventListener('click', () => {
      if (this.$store.state.hover) {
        this.$router.push(this.$store.state.hoveredCard.slug)
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'single-card') {
      const tl = gsap.timeline({ onComplete: next })
      document.body.style.backgroundColor = 'var(--black)'
      tl.to(this.$el.querySelector('.transition-helper'), { width: '50vw', duration: 1, ease: 'expo.inOut' }, 0)
        .to(this.$el.querySelector('.megacanvas'), { autoAlpha: 0, duration: 1, ease: 'expo.inOut' }, 0)
      this.$store.commit('fixCursor', true)
      this.$store.commit('hoverOnCard', false)
    } else if (to.name === 'finale') {
      const tl = gsap.timeline({ onComplete: next })
      document.body.style.backgroundColor = 'var(--black)'
      tl.to(this.$el.querySelector('.megacanvas'), { autoAlpha: 0, duration: 1, ease: 'expo.inOut' }, 0)
    }
  }
}
</script>

<style lang="scss">
.Home {
  .sharebtn {
    position: absolute;
    bottom: 24px;
    left: 24px;
    z-index: 99;
  }

  .bigText {
    font-family: $font-grand;
    font-weight: 800;
    font-size: 7vw;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 10vw;
    right: 10vw;
    margin: 0;
    transform: translate3d(0, -50%, 0);
    pointer-events: none;
    transition: opacity .2s ease-out;

    @media (min-width:1440px) {
      font-size: 100px;
    }
  }

  .transition-helper {
    position: absolute;
    z-index: 10;
    right: 0;
    top: 0;
    bottom: 0;
    width: 0;
    background-color: $white;
  }
}
</style>
